import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhoneDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPhoneDynamicIsland"><Path fillRule="evenodd" clipRule="evenodd" d="M7.5 23C6.11929 23 5 21.8807 5 20.5V3.5C5 2.11929 6.11929 1 7.5 1H16.5C17.8807 1 19 2.11929 19 3.5V20.5C19 21.8807 17.8807 23 16.5 23H7.5ZM10.5 3C10.2239 3 10 3.22386 10 3.5C10 3.77614 10.2239 4 10.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhoneDynamicIsland;
